import { useQuery } from '@tanstack/react-query'
import { paymentApprovalKeys } from '../keys'
import { paymentApprovalApi } from '../api'

export default function useGetApprovalRulesConfig() {
  return useQuery({
    queryFn: paymentApprovalApi.getApprovalRuleConfig,
    queryKey: paymentApprovalKeys.approvalRules(),
  })
}
